import React, { forwardRef } from 'react';
import { LEVEL_FLOW_TYPE } from 'domain/approvals/constatns';
import elements from 'components/elements';

import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import { UserOrApproverRoot, CustomChip, KeyboardArrowRightIcon } from 'pages/components/Approver/StyledComponents';

import MuiKeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ReactComponent as ParallelIcon } from './icons/ParallelArrows.svg';
import { ReactComponent as SequenceIcon } from './icons/SequenceArrows.svg';

const colors = {
  draft: undefined,
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
};

const getIconByType = (arrowIconType) => {
  switch (arrowIconType) {
    case LEVEL_FLOW_TYPE.PARALLEL:
      return ParallelIcon;
    case LEVEL_FLOW_TYPE.SEQUENTIAL:
      return SequenceIcon;
    default:
      return MuiKeyboardArrowRightIcon;
  }
};

const Approver = forwardRef(
  (
    {
      hasArrow = true,
      status,
      arrowDirection = 'row',
      isLevel = false,
      spacing = 0.5,
      size = 'medium',
      chipHeight = 'inherit',
      arrowIconType,
      sx,
      withoutBorderForLevelContainer = false,
      chipProps = {},
      ...props
    },
    ref,
  ) => (
    <UserOrApproverRoot minWidth={isLevel ? 0 : 90} direction={arrowDirection} spacing={spacing} ref={ref} sx={sx}>
      <CustomChip
        data-element={elements.content.documents.approvals.approvalItem}
        variant="outlined"
        color={colors[status]}
        status={status}
        size={size}
        isLevel={isLevel}
        direction={arrowDirection}
        withoutBorderForLevelContainer={withoutBorderForLevelContainer}
        {...props}
        {...chipProps}
      />
      {hasArrow && (
        <Stack>
          {arrowIconType ? (
            <SvgIcon component={getIconByType(arrowIconType)} inheritViewBox fontSize={size} />
          ) : (
            <KeyboardArrowRightIcon arrowDirection={arrowDirection} fontSize={size} />
          )}
        </Stack>
      )}
    </UserOrApproverRoot>
  ),
);

export default Approver;
